import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { trackReports } from '../../../../core/constants/constants';
import { TrackMXVarResponse } from '../../../../core/interface/mx-reports';
import { VarianceReportData } from '../../../../core/interface/export-reports';

@Component({
  standalone: false,
  selector: 'app-track-mx-var',
  templateUrl: './track-mx-var.component.html',
  styleUrl: './track-mx-var.component.less',
})
export class TrackMxVarComponent implements OnChanges {
  trackReport = trackReports;
  @Input()
  trackMXVarResponse!: TrackMXVarResponse[];
  @Input()
  reportData!: VarianceReportData;
  totalTrackSum: number = 0;
  totalMaxSum: number = 0;
  totalVarSum: number = 0;
  totalTrackCost: number = 0;
  totalMaxCost: number = 0;
  totalVarCost: number = 0;
  companyName: string = '';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['trackMXVarResponse'].currentValue != null) {
      this.calculateSum();
      this.companyName = this.trackMXVarResponse[0].companyName;
    }
  }

  calculateSum() {
    this.totalTrackSum = 0;
    this.totalMaxSum = 0;
    this.totalVarSum = 0;
    this.totalTrackCost = 0;
    this.totalMaxCost = 0;
    this.totalVarCost = 0;
    this.trackMXVarResponse.forEach((response) => {
      this.totalTrackSum += response.sumTrackHrs;
      this.totalTrackCost += response.sumTrackCost;
      this.totalMaxSum += response.sumMaxHrs;
      this.totalMaxCost += response.sumMaxCost;
      this.totalVarSum += response.sumVarHrs;
      this.totalVarCost += response.sumVarCost;
    });
  }
}
